const { useTranslation } = require("react-i18next");
const { default: Icon } = require("../../common/components/Icon");
const { buildColor } = require("../../common/utils/tableUtilities");
const { useEpcrHistory } = require("../../reducers/epcrSlice");
const { useStatsContext } = require("./JobStatsContext");

const PCRStatsListEntry = ({ pcr, selectedPcrID, disabled, onClick }) => {
    const { t } = useTranslation();

    const buttonColor = buildColor('#ffffff', selectedPcrID?.toString() === pcr.id?.toString());

    const handleClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };

    return <div className="pb-2 px-2">
        <button type="button" className="w-100 d-block" style={{ border: 'none', padding: 0, textAlign: 'initial', ...buttonColor }} onClick={handleClick}>
            <div style={{ display: 'grid', gridTemplateColumns: '20px repeat(12, 1fr) ' }}>
                <div style={{ gridColumn: '1/2' }} className="border border-dark border-right-0 text-center">{pcr.finalized && <Icon intent="locked"></Icon>}</div>
                <div style={{ gridColumn: '2/4' }} className="border border-dark border-right-0 pl-2">{t('pcrNumber')}: {pcr.displayid}</div>
                <div style={{ gridColumn: '4/6' }} className="border border-dark border-right-0">{t('age')}: {pcr.age}</div>
                <div style={{ gridColumn: '6/8' }} className="border border-dark border-right-0">{t('gender')}: {pcr.gender}</div>
                <div style={{ gridColumn: '8/14' }} className="border border-dark">{t('chiefComplaint')}: {pcr.problem}</div>
            </div>
        </button>
    </div>;
};

export const PCRStatsList = () => {
    const { search } = useStatsContext();
    const pcrs = useEpcrHistory(search.creationAfter, search.creationBefore);

    return <div class="d-flex flex-column h-100 w-100" style={{ overflowY: 'auto' }}>
        {pcrs.map(pcr => <PCRStatsListEntry key={pcr.id} pcr={pcr}></PCRStatsListEntry>)}
    </div>;
};